import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router';
import TabbedPage from 'components/TabbedPage';
import ControlPanel from 'components/Meteorology/Agro/ControlPanel';
import RightSidebar from 'components/Layout/RightSidebar';
import { openRight } from 'redux/reducers/sidebarsReducer';
import TitleLarge from 'components/Typography/TitleLarge';
import MobileSectionHeader from 'components/Layout/MobileShell/MobileSectionHeader';
import SectionTabs, { SectionTabItem } from 'components/Layout/MobileShell/SectionTabs';
import MoreSheet from 'components/Layout/MobileShell/MoreSheet';
import useIsMobile from 'utils/hooks/useIsMobile';
import shortenedTabPath from 'helper/shortenedTabPath';

const SIDEBAR_PATHS = [
  'water-balance-sequential/detailed-view',
  'water-balance-culture/',
  'culture-index/',
  'trackingforecast/',
  'similarity',
];

const MOBILE_TABS: SectionTabItem[] = [
  { title: 'Cadastro', path: '/agro/register' },
  { title: 'Visão Geral', path: '/agro/overview/' },
  { title: 'Acompanhamento/Previsão', path: '/agro/trackingforecast/detailedview/' },
  { title: 'Balanço Hídrico - Sequencial', path: '/agro/water-balance-sequential/' },
  { title: 'Balanço Hídrico - Cultura', path: '/agro/water-balance-culture/' },
  { title: 'Similaridade', path: '/agro/similarity' },
  { title: 'Índice por Cultura', path: '/agro/culture-index/' },
];

export default function AgroLayout() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [moreOpen, setMoreOpen] = useState(false);
  const showSidebar = SIDEBAR_PATHS.some((path) => location.pathname.includes(path));

  useEffect(() => {
    dispatch(openRight());
  }, [dispatch]);

  if (isMobile) {
    const activeTab = MOBILE_TABS.find(
      (tab) => tab.path === shortenedTabPath(location.pathname),
    );

    return (
      <>
        <MobileSectionHeader
          backLabel="Agrometeorologia"
          title={activeTab?.title ?? ''}
          onBack={() => navigate('/meteorology')}
          onAvatarClick={() => setMoreOpen(true)}
        />
        <SectionTabs tabs={MOBILE_TABS} />
        <Outlet />
        <MoreSheet open={moreOpen} dismiss={() => setMoreOpen(false)} />
      </>
    );
  }

  return (
    <>
      <Row>
        <div className="mb-5 text-medium-blue">
          <TitleLarge>Agrometeorologia</TitleLarge>
        </div>
      </Row>
      <Row style={{ flexWrap: 'nowrap', paddingBottom: '3.3125rem' }}>
        <Col xs="auto" className="flex-fill overflow-hidden">
          <TabbedPage>
            <TabbedPage.Tab
              title="CADASTRO"
              path="/agro/register"
            />
            <TabbedPage.Tab
              title="VISÃO GERAL"
              path="/agro/overview/"
            />
            <TabbedPage.Tab
              title="ACOMPANHAMENTO/PREVISÃO"
              path="/agro/trackingforecast/detailedview/"
            />
            <TabbedPage.Tab
              title="BALANÇO HÍDRICO - SEQUENCIAL"
              path="/agro/water-balance-sequential/"
            />
            <TabbedPage.Tab
              title="BALANÇO HÍDRICO - CULTURA"
              path="/agro/water-balance-culture/"
            />
            <TabbedPage.Tab
              title="SIMILARIDADE"
              path="/agro/similarity"
            />
            <TabbedPage.Tab
              title="ÍNDICE POR CULTURA"
              path="/agro/culture-index/"
            />
          </TabbedPage>
        </Col>
        {showSidebar && (
          <Col xs="auto">
            <RightSidebar>
              <ControlPanel />
            </RightSidebar>
          </Col>
        )}
      </Row>
      <div className="bottom-bar" />
    </>
  );
}
